module.exports = __webpack_public_path__ + "img/about-icons-nlp-web.03ce129f.svg";